export default __webpack_public_path__ + "static/media/13.d77d6698.png";